import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Login from './components/Login';
import Register from './components/Register';
import Requests from './components/Requests';
import RequestDetail from './components/RequestDetail';
import NewRequest from './components/NewRequest';
import MagicLink from './components/MagicLink';
import VerifyEmail from './components/VerifyEmail';
import MyRequests from './components/MyRequests';
import MyQuotes from './components/MyQuotes';
import Pricing from './components/Pricing';
import Dashboard from './components/Dashboard';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Contact from './components/Contact';
import SupportChat from './components/SupportChat';
import Settings from './components/Settings';
import SocialMediaAdmin from './components/SocialMediaAdmin';
import ProspectResearch from './components/ProspectResearch';
import AdminDashboard from './components/AdminDashboard';
import AdminDisputes from './components/AdminDisputes';

function App() {
  return (
    <BrowserRouter>
      <div style={styles.app}>
        <Navbar />
        <main style={styles.main}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/auth/magic-link" element={<MagicLink />} />
            <Route path="/auth/verify-email" element={<VerifyEmail />} />
            <Route path="/requests" element={<Requests />} />
            <Route path="/request/:id" element={<RequestDetail />} />
            <Route path="/new-request" element={<NewRequest />} />
            <Route path="/my-requests" element={<MyRequests />} />
            <Route path="/my-quotes" element={<MyQuotes />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/social" element={<SocialMediaAdmin />} />
            <Route path="/admin/prospects" element={<ProspectResearch />} />
            <Route path="/admin/disputes" element={<AdminDisputes />} />
          </Routes>
        </main>
        <SupportChat />
      </div>
    </BrowserRouter>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  app: {
    minHeight: '100vh',
    backgroundColor: '#f5f6fa',
  },
  main: {
    minHeight: 'calc(100vh - 60px)',
  },
};

export default App;
